<template>
  <v-dialog v-model='showModal' persistent max-width='800' :overlay='true'>
    <v-card>
      <v-toolbar tabs>
        <v-toolbar-title  id='title'>Import Data File</v-toolbar-title>
      </v-toolbar>
      <v-layout class='my-3'>
        <v-spacer></v-spacer>
        <input type='file' accept='.csv,.json' multiple=true ref='input'>
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn color='info' :loading='loading' :disabled='loading' @click.native='importFile'>
          Import
          <v-icon right>cloud_upload</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-layout>
      <v-toolbar tabs>
        <i>Only .csv files are currently supported</i>
        <v-spacer></v-spacer>
        <v-btn class='black--text' flat @click.native='$emit("hide-modal")'>Close</v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>

<script>
import Papa from 'PapaParse'
export default {
  data: () => ({
    loading: false
  }),
  methods: {
    importFile() {
      if(this.$refs.input.files.length>0) {
        this.loading = true;
        for(var file of this.$refs.input.files) {
          var config = {
            delimiter: ';',
            header: true,
            trimHeaders: true,
            dynamicTyping: true,
            skipEmptyLines: 'greedy',
            complete: this.importSuccessCallback,
            error: this.importErrorCallback
          };
          Papa.parse(file, config);
        }
      }
    },
    importSuccessCallback(results, file) {
      // clean cells with empty content
      var emptySpace = ["''", "\"", "\"\""];
      for(var line of results.data)
        for(var prop of Object.keys(line))
          if(emptySpace.includes(line[prop]))
            line[prop] = '';
      var headers = Object.keys(results.data[0])
      var modData = {
        name: file.name,
        type: 'data',
        output: {
          data: results.data,
          headers: headers
        }
      };
      this.$emit('add-data', 'data', modData);
      setTimeout(() => {
        this.loading = false;
        this.$emit('hide-modal');
      }, 100);
    },
    importErrorCallback(error, file) {
      // TODO: error handling, etc...
      console.log('Parsing error:', error, file);
      setTimeout(() => {
        this.loading = false;
        this.$emit('hide-modal');
      }, 100);
    }
  },
  props: {
    showModal: Boolean
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Workspace/Menus/ImportDataFileModal.vue